<script lang="ts">
    import {createClientStore} from '$lib/stores/createClientStore';
    import type {IdName} from '$lib/models/types';
    import {AliiOCRTypes, ClientStatuses} from '$lib/models/client/types';

    export let connectionTypes: IdName[];
  export let exportTypes: IdName[];

  const request = createClientStore.request;
</script>

<div class="border border-surface-500 p-5 rounded-container-token">
  <div>
    <div class="mb-1 text-xl font-extrabold text-primary-500">Client Details</div>
    <div class="grid grid-cols-1 lg:grid-cols-2">
      <div>
        <div class="mb-5">
          <div class="label font-bold">Client Name</div>
          <div>
            {$request.clientName}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">Client Status</div>
          <div>
            {ClientStatuses.find((ct) => ct.id === $request.clientStatus)?.name}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">Connection Type</div>
          <div>
            {connectionTypes.find((ct) => ct.id === $request.connectionTypeId)?.name}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">Export Type</div>
          <div>
            {exportTypes.find((ct) => ct.id === $request.exportTypeId)?.name}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">OCR Type</div>
          <div>
            {AliiOCRTypes.find((ot) => ot.id === $request.aliiOCRType)?.name}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">Location</div>
          <div>
            {$request.location}
          </div>
        </div>
        <div class="mb-5">
          <div class="label font-bold">Organisation</div>
          <div>
            {$request.organisationName}
            {#if $request.createNewOrganisation}
              <span class="text-xs text-surface-400">(New)</span>
            {/if}
          </div>
        </div>
      </div>
      <div>
        <div class="label font-bold">Domains</div>
        <div>
          {#each $request.domains as domain}
            <div>
              {domain}
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
  <hr class="divider my-5" />
  <div>
    <div class="mb-1 text-xl font-extrabold text-primary-500">Initial User</div>
    <div>
      <div class="mb-5">
        <div class="label font-bold">Username/Email</div>
        <div>
          {$request.initialUserDetails.username}
        </div>
      </div>
      <div class="mb-5">
        <div class="label font-bold">Password</div>
        <div>
          {$request.initialUserDetails.password}
        </div>
      </div>
      <div class="mb-5">
        <div class="label font-bold">Name</div>
        <div>
          {$request.initialUserDetails.name}
        </div>
      </div>
    </div>
  </div>
  <hr class="divider my-5" />
  <div>
    <div class="mb-1 text-xl font-extrabold text-primary-500">Permissions</div>
    {#each $request.menuConfigs.filter((mc) => mc.enabled) as menuConfig}
      <div class="mb-5">
        {menuConfig.name}
      </div>
    {/each}
  </div>
</div>
